import type { ThemeMode } from '@/viewmodel/shared/theme/state/themeStorage';
import { createContext } from 'react';

export interface ThemeContextValue {
  readonly mode: ThemeMode;
  readonly isDark: boolean;
  readonly setMode: (mode: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
